//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class AddConceptVersionModel extends ModelBase {
      static readonly $typeName = 'AddConceptVersionModel';
      public code: string;
      public name: string;
      public valueSetCode: string;
      public codeSystemVersionKey: string;
      public isMappedCodeSystem: boolean;
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/AddConceptVersionModel.ts